"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSite = void 0;
const react_1 = require("react");
const contexts_1 = require("../contexts");
function useSite() {
    const value = react_1.useContext(contexts_1.SiteContext);
    if (!value) {
        throw new Error('Use ProspectProvider or LocationProvider to use this hook.');
    }
    return value;
}
exports.useSite = useSite;
//# sourceMappingURL=useSite.js.map